<!--
  Mobile 端 Footer：复用 PC Footer 结构与资源，适配手机布局
-->
<template>
  <footer class="mobile-footer">
    <div class="mobile-footer-row">
      <div class="mobile-footer-mascot">
        <img
          src="@/assets/image/logo/app.webp"
          :alt="footerImgAlt.appIcon"
          class="mobile-footer-mascot-img"
          width="80"
          height="80"
          decoding="async"
        />
      </div>
      <div class="mobile-footer-download">
        <div class="mobile-footer-download-tip">
          <p class="mobile-footer-download-label">
            {{ pcFooterCopy.appDownloadLabel }}
          </p>
          <div class="mobile-footer-download-line" aria-hidden="true" />
        </div>
        <div class="mobile-footer-badges">
          <a
            :href="pcFooterLinks.appStore"
            target="_blank"
            rel="noopener noreferrer"
            class="mobile-footer-badges-link"
          >
            <img
              src="@/assets/image/logo/AppStore.webp"
              :alt="footerImgAlt.appStoreBadge"
              class="mobile-footer-badges-img1"
              width="132"
              height="44"
              decoding="async"
            />
          </a>
          <a
            :href="pcFooterLinks.googlePlay"
            target="_blank"
            rel="noopener noreferrer"
            class="mobile-footer-badges-link"
          >
            <img
              src="@/assets/image/logo/GooglePlay.webp"
              :alt="footerImgAlt.googlePlayBadge"
              class="mobile-footer-badges-img2"
              width="144"
              height="42"
              decoding="async"
            />
          </a>
        </div>
      </div>
    </div>

    <div class="mobile-footer-divider"></div>

    <nav
      class="mobile-footer-legal"
      :aria-label="pcFooterCopy.legalNavAriaLabel"
    >
      <div class="mobile-footer-legal-item">
        <a
          :href="footerLegalLinks[0].href"
          class="mobile-footer-legal-link"
          >{{ footerLegalLinks[0].label }}</a
        >
        <span class="mobile-footer-legal-sep" aria-hidden="true">|</span>
        <a
          :href="footerLegalLinks[1].href"
          class="mobile-footer-legal-link"
          >{{ footerLegalLinks[1].label }}</a
        >
      </div>

      <div class="mobile-footer-legal-item">
        <a
          :href="footerLegalLinks[2].href"
          class="mobile-footer-legal-link"
          >{{ footerLegalLinks[2].label }}</a
        >
        <span class="mobile-footer-legal-sep" aria-hidden="true"> | </span>
        <a
          :href="footerLegalLinks[3].href"
          class="mobile-footer-legal-link"
          >{{ footerLegalLinks[3].label }}</a
        >
      </div>

      <div class="mobile-footer-legal-item">
        <a
          :href="footerLegalLinks[4].href"
          class="mobile-footer-legal-link"
          >{{ footerLegalLinks[4].label }}</a
        >
      </div>
    </nav>

    <div class="mobile-footer-partner">
      <a
        :href="pcFooterLinks.yostar"
        target="_blank"
        rel="noopener noreferrer"
        class="mobile-footer-partner-link"
      >
        <img
          src="@/assets/image/logo/YOSTAR.webp"
          :alt="footerImgAlt.yostarWordmark"
          class="mobile-footer-partner-img"
          width="120"
          height="34"
          decoding="async"
        />
      </a>
      <a
        :href="pcFooterLinks.nexon"
        target="_blank"
        rel="noopener noreferrer"
        class="mobile-footer-partner-link"
      >
        <img
          src="@/assets/image/logo/NEXON.webp"
          :alt="footerImgAlt.nexonWordmark"
          class="mobile-footer-partner-img"
          width="120"
          height="34"
          decoding="async"
        />
      </a>
    </div>

    <p class="mobile-footer-copy">{{ pcFooterCopy.copyrightLine }}</p>
  </footer>
</template>

<script>
import indexContent from "@/views/data/index-content.json";

const PC_FOOTER = indexContent.pcFooter;

export default {
  name: "MobileFooter",
  data() {
    return {
      pcFooterCopy: PC_FOOTER.pcFooterCopy,
      pcFooterLinks: PC_FOOTER.pcFooterLinks,
      footerLegalLinks: PC_FOOTER.footerLegalLinks,
      footerImgAlt: PC_FOOTER.imgAlt,
    };
  },
};
</script>

<style lang="scss" scoped>
.mobile-footer {
  width: 100%;
  background: #1f1f1f;
  box-sizing: border-box;
  padding: 66px 36px 140px;
  color: #ffffff;
  animation: mobile-footer-in 0.4s ease-out both;

  &-divider {
    flex: 1;
    min-width: 80px;
    height: 1px;
    background: #36e9ff;
    margin: 40px 0;
  }

  img {
    box-sizing: border-box;
    vertical-align: middle;
  }

  &-row {
    display: flex;
    // flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }

  &-mascot {
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    background: transparent;

    &-img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-download {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding-top: 10px;

    &-tip {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
      flex-wrap: wrap;
    }

    &-label {
      margin: 0;
      font-size: 12px;
      font-weight: 700;
      color: #36e9ff;
      line-height: 100%;
      white-space: nowrap;
    }
    &-line {
      flex: 1;
      min-width: 80px;
      height: 1px;
      background: #36e9ff;
    }
  }

  &-badges {
    display: flex;
    align-items: flex-start;
    width: 100%;
    gap: 6px;

    &-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;

      &:focus-visible {
        outline: 2px solid #36e9ff;
        outline-offset: 2px;
        border-radius: 8px;
      }
    }

    &-img1 {
      width: auto;
      height: 44px;
      max-width: 180px;
      object-fit: contain;
    }
    &-img2 {
      width: auto;
      height: 42px;
      max-width: 180px;
      object-fit: contain;
    }
  }

  &-partner-inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    margin-bottom: 26px;
  }

  &-partner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 30px;
    width: 100%;
    margin-bottom: 26px;

    &-link {
      display: inline-flex;
      align-items: center;

      &:focus-visible {
        outline: 2px solid #36e9ff;
        outline-offset: 2px;
      }
    }

    &-img {
      max-width: 130px;
      height: 34px;
      object-fit: contain;
    }
  }

  &-legal {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    font-family: 'Noto Sans JP', 'Noto Sans', sans-serif;
    width: 100%;
    overflow-x: auto;
    margin-bottom: 38px;

    &-item {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    &-item:not(:last-child) {
      margin-bottom: 8px;
    }

    &-link {
      color: #d2d4e1;
      text-decoration: none;
      white-space: nowrap;

      &:hover,
      &:active {
        color: #fff;
      }

      &:focus-visible {
        outline: 2px solid #36e9ff;
        outline-offset: 2px;
      }
    }

    &-sep {
      color: #8d95af;
      user-select: none;
    }
  }

  &-copy {
    text-align: center;
    font-size: 12px;
    color: #b9bed0;
  }
}

@keyframes mobile-footer-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobile-footer {
    animation: none;
  }
}
</style>
